import './style.scss';
const AttributeItem = ({name, value} : {name: string, value: string}) => {
    return <div className="single__attribute-item item-attribute">
        {name && <div className="item-attribute__name">{name}</div>}
        {value && <div className="item-attribute__value">{value}</div>}
    </div>
}

export default AttributeItem